// extracted by mini-css-extract-plugin
export default {"wrapper":"PCOSRiskScreen_wrapper__DrNdV","cardFixedLayout":"PCOSRiskScreen_cardFixedLayout__bMqJo","cardPC":"PCOSRiskScreen_cardPC__lXwB0","card":"PCOSRiskScreen_card__wWYlb"};